(function ($) {
    $(window).on('resize', screenSize.change);
})(jQuery);